import Audit from '@components/LocalMerchant/LiteApp/Audit'
import Authorize from '@components/LocalMerchant/LiteApp/Authorize'
import Help from '@components/LocalMerchant/LiteApp/Help'
import Home from '@components/LocalMerchant/LiteApp/Home'
import LiteAppIntro from '@components/LocalMerchant/LiteApp/Intro'
import Manage from '@components/LocalMerchant/LiteApp/Manage'
import Register from '@components/LocalMerchant/LiteApp/Register'
import SetLayout from '@components/LocalMerchant/LiteApp/SetLayout'
import React from 'react'

export default {
  path: 'liteApp',
  indexRoute: {
    component: props => <Home {...props} />
  },
  childRoutes: [
    {
      path: 'setLayout',
      component: SetLayout,
      stat: '小程序/小程序设置'
    },
    {
      path: 'register',
      component: Register,
      stat: '小程序/小程序注册'
    },
    {
      path: 'manage',
      component: Manage,
      stat: '小程序/管理页'
    },
    {
      path: 'help',
      component: Help
    },
    {
      path: 'authorize',
      component: Authorize,
      stat: '小程序/小程序授权页'
    },
    {
      path: 'audit',
      component: Audit
    },
    {
      path: 'intro',
      component: LiteAppIntro
    }
  ]
}
